import React, { PureComponent } from 'react'
import { View, Image } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Button from '../../Atoms/Button'
import InlineError from '../../Atoms/InlineError'

import theme from '../../../styles/theme'

const source = require('../../../assets/excelerate-logo.png')

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.black};
`

const Body = styled(View)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.black};
  align-items: center;
  justify-content: center;
`

const Logo = styled(Image)`
  width: 235px;
  height: 120px;
`

class DiagnosePage extends PureComponent {
  render () {
    const { gameApiChecking, gameApiCheckComplete, gameApiError, onGameApiStatusCheck, eventApiChecking, eventApiCheckComplete, eventApiError, onEventApiStatusCheck } = this.props
    const gameApiButtonEnabled = !gameApiChecking
    const gameApiStatus = gameApiChecking ? 'Checking' : gameApiCheckComplete ? 'Success' : gameApiError ? 'Error' : 'Unknown'

    const eventApiButtonEnabled = !eventApiChecking
    const eventApiStatus = eventApiChecking ? 'Checking' : eventApiCheckComplete ? 'Success' : eventApiError ? 'Error' : 'Unknown'
    return (
      <Container>
        <Body>
          <Logo source={source} resizeMode='contain' />
          <Text size='xl' white overrides={{ marginTop: theme.gutterUnit * 2 }}>Game Connectivity</Text>
          <Text size='m' white overrides={{ marginTop: theme.gutterUnit * 2 }}>Status: {gameApiStatus}</Text>
          {gameApiError && <InlineError message={gameApiError.message} />}
          <Button
            data-test='disagnose-game-api'
            primary={gameApiButtonEnabled}
            darkgrey={!gameApiButtonEnabled}
            rounded
            onPress={onGameApiStatusCheck}
            disabled={!gameApiButtonEnabled}
            styles={[{ width: 300, marginTop: theme.gutterUnit, padding: 2 * theme.gutterUnit, height: 50 }]}
          >
            <Text size='s' white>Check Connectivity</Text>
          </Button>

          <Text size='xl' white overrides={{ marginTop: theme.gutterUnit * 2 }}>Event Connectivity</Text>
          <Text size='m' white overrides={{ marginTop: theme.gutterUnit * 2 }}>Status: {eventApiStatus}</Text>
          {eventApiError && <InlineError message={eventApiError.message} />}
          <Button
            data-test='disagnose-game-api'
            primary={eventApiButtonEnabled}
            darkgrey={!eventApiButtonEnabled}
            rounded
            onPress={onEventApiStatusCheck}
            disabled={!eventApiButtonEnabled}
            styles={[{ width: 300, marginTop: theme.gutterUnit, padding: 2 * theme.gutterUnit, height: 50 }]}
          >
            <Text size='s' white>Check Connectivity</Text>
          </Button>
        </Body>
      </Container>
    )
  }
}

export default DiagnosePage
